module.exports = __webpack_public_path__ + "img/certificate_head2.f538dd31.png";